import React from 'react';
import './bookingShared.css';
import './bookingConfirmed.css';
import './bookingStep3.css';
import { Link } from 'react-router-dom';


const TICKET_LABELS = { day: "One Day Pass", vip: "VIP" };
const PRICES = { day: 9, vip: 200 };

export default function BookingConfirmed({ formData }) {
  const totalPaid = PRICES[formData.ticketType] * (formData.quantity ?? 1);

  return (
    <div className="bookingForm">
      <h2 className="confirmedTitle">Booking Confirmed!</h2>
      <p className="confirmedSubtitle">Your visit to CIBF 2027 is all set</p>

      <div className="ticketSummary">
        <h3 className="summaryTitle">Ticket Summary</h3>
        <div className="summaryRow">
          <h4>Date:</h4>
          <h4>{formData.date}</h4>
        </div>
        <div className="summaryRow">
          <h4>Ticket Type:</h4>
          <h4>{TICKET_LABELS[formData.ticketType]}</h4>
        </div>
        <div className="summaryRow">
          <h4>Number of Tickets:</h4>
          <h4>{formData.quantity}</h4>
        </div>
        <div className="summaryRow total">
          <h4>Total Paid:</h4>
          <h4>{totalPaid} EGP</h4>
        </div>
      </div>

      <button className="viewTicketBtn">View My Ticket</button>
      <Link to="/" className='link'>
        <button className="backHomeBtn width100">Back to Home</button>
      </Link>
    </div>
  );
}